import { SettingOutlined } from '@ant-design/icons';
import { Button, Drawer, Tabs } from 'antd';
import PropTypes from 'prop-types';
import { useState } from 'react';
import AgentCollectionConfig from './AgentCollectionConfig';
import AgentConnectionConfig from './AgentConnectionConfig';
import AgentScheduleTable from './AgentScheduleTable';
import AgentOperationPlanImport from '../components/AgentOperationPlanImport';
import { getCollectionAgentDefinition } from '../utils/collection-agent';

const AgentConfigDrawer = ({ agent, onRun, organizationId }) => {
  const [open, setOpen] = useState(false);
  const collectionAgent = agent.configuration?.type === 'collection';
  const manualUploadAgent = agent.configuration?.type === 'manual-upload';
  const collectionDefinition = collectionAgent
    ? getCollectionAgentDefinition(agent.configuration)
    : undefined;
  const schedule = (
    <AgentScheduleTable agent={agent} allowCreate organizationId={organizationId} onRun={onRun} />
  );
  let content = schedule;
  if (collectionAgent) {
    content = (
      <Tabs
        defaultActiveKey="connections"
        items={[
          {
            key: 'connections',
            label: collectionDefinition.connectionLabel,
            children: <AgentConnectionConfig agent={agent} organizationId={organizationId} />,
          },
          {
            key: 'collections',
            label: '采集配置',
            children: <AgentCollectionConfig agent={agent} organizationId={organizationId} />,
          },
          { key: 'schedules', label: '定时任务', children: schedule },
        ]}
      />
    );
  }
  if (manualUploadAgent) {
    content = (
      <AgentOperationPlanImport
        organizationId={organizationId}
        onCompleted={() => {
          setOpen(false);
          onRun();
        }}
      />
    );
  }

  return (
    <>
      <Button type="link" icon={<SettingOutlined />} onClick={() => setOpen(true)}>
        配置
      </Button>
      <Drawer
        title={`配置 ${agent.title}`}
        size="min(1080px, 92vw)"
        open={open}
        destroyOnHidden
        onClose={() => setOpen(false)}
      >
        {content}
      </Drawer>
    </>
  );
};

AgentConfigDrawer.propTypes = {
  agent: PropTypes.shape({
    configuration: PropTypes.shape({ connectionType: PropTypes.string, type: PropTypes.string }),
    title: PropTypes.string.isRequired,
  }).isRequired,
  onRun: PropTypes.func.isRequired,
  organizationId: PropTypes.string.isRequired,
};

export default AgentConfigDrawer;
